import { useSelector } from 'react-redux'

import { getSubOrders } from 'shared/store-checkout/duck/common'
import ShipmentBySubOrder from 'views/components/organisms/Checkout/ShipmentBySubOrder'

const ShippingCostInformationModalContent = () => {
  const subOrders = useSelector(state => getSubOrders(state))
  return (
    <>
      {subOrders.map((subOrder, index) => {
        return (
          <div
            key={subOrder.subOrderId}
            className="u-padding-large u-background-color--background u-margin-large--bottom u-border-radius"
          >
            <ShipmentBySubOrder
              sellerNumber={index + 1}
              sellerCount={subOrders.length}
              sellerId={subOrder.sellerId}
              subOrderId={subOrder.subOrderId}
              totalAmount={subOrder.totalAmount}
              deliveryMode={subOrder.carrier?.method}
              freeShippingBargain={subOrder.placeHolders?.freeShippingBargain}
              shippingCosts={subOrder.carrier?.shippingCost}
              hasMarketPlaceOrders
              isShippingCostModal
            />
          </div>
        )
      })}
    </>
  )
}

export default ShippingCostInformationModalContent
